module.exports = __webpack_public_path__ + "static/media/MoleculesRight.b68e0e37.svg";